import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/ui/components/SideMenu/index.tsx");
